
import './vendor/jquery.inview.js';

$.fn.extend({
  animateCss: function(animationName, callback) {
    var animationEnd = (function(el) {
      var animations = {
        animation: 'animationend',
        OAnimation: 'oAnimationEnd',
        MozAnimation: 'mozAnimationEnd',
        WebkitAnimation: 'webkitAnimationEnd',
      };

      for (var t in animations) {
        if (el.style[t] !== undefined) {
          return animations[t];
        }
      }
    })(document.createElement('div'));

    this.addClass('animated ' + animationName).one(animationEnd, function() {
      $(this).removeClass('animated ' + animationName);

      if (typeof callback === 'function') callback();
    });

    return this;
  },
});


function animate() {

	$('.animate').each(function(){
		
		$(this).on('inview', function(e, isInView) {
		  
		  var $el = $(this);
		  var animation = $(this).attr('data-animate');
		  var delay = $(this).attr('data-delay');
		  var loop = $(this).attr('data-loop');

		  if(animation === undefined)
		  	animation = 'fadeIn';

		  if(delay === undefined)
		  	delay = 200;

		  if(loop === undefined)
		  	loop = 'false';


		  if (isInView) {

		  	// Ya fue animado y no se requiere loop.
		  	if( loop == 'false' && $el.css('opacity') == 1 )
		  		return false;

		  	setTimeout(function(){ 

		  		$el.animateCss(animation, function(){
		  			$el.css('opacity', 1);
		  		});

		  	 }, delay);
		  	
		  } else {

		  	if(loop == 'true')
		  	{
		  		$(this).css('opacity', 0);
		  		$(this).removeClass(animation);
		  	}

		  }
		});
	});

}

function show_all(selector) {
	$(selector).each(function(){
		
		var $el = $(this);
		var animation = $(this).attr('data-animate');
		var delay = $(this).attr('data-delay');
		var loop = $(this).attr('data-loop');

		if(animation === undefined)
		  	animation = 'fadeIn';

		  if(delay === undefined)
		  	delay = 200;

		  if(loop === undefined)
		  	loop = 'false';

		  setTimeout(function(){ 
		  	$el.animateCss(animation, function(){
		  			$el.css('opacity', 1);
		  		});
		   }, delay);
	});

}


function hide_all(selector) {

	$(selector).each(function(){
		
		var $el = $(this);
		var animation = $(this).attr('data-animate');		

		if(animation === undefined)
		  	animation = 'fadeIn';		  
		  
		  $(this).css('opacity', 0);
		  $el.removeClass(animation);

	});

}

window.animate = animate;
window.show_all = show_all;
window.hide_all = hide_all;

animate();

